export default "__VITE_ASSET__CoUABV2U__"